import useSWR from "swr";
import { useState } from "react";
import { clinikoApi } from "../../api/cliniko.api";

export const CHECKLIST_ITEMS = [
  { key: 'clinikoConnected', label: 'Connect Cliniko', path: '/onboarding', permission: 'cliniko.manage' },
 { key: 'googleBusinessLinked', label: 'Link Google Business', path: '/onboarding', permission: 'settings.manage' },
  { key: 'widgetCreated', label: 'Create a Widget', path: '/rate-my-business/widgets', action: 'create-widget', permission: 'rmb.widgets.create' },
  { key: 'funnelCreated', label: 'Create a Feedback Funnel', path: '/rate-my-business/widgets', action: 'create-funnel', permission: 'rmb.widgets.create' },
   { key: 'businessNameSet', label: 'Set Sender ID (Business Name)', path: '/settings?tab=cellcast', permission: 'settings.manage' },
  { key: 'smsCreditsAdded', label: 'Buy SMS Credits', path: '/billing', permission: 'billing.manage' },
  
  { key: 'workflowCreated', label: 'Create SMS Automation', path: '/automation-workflows', action: 'create', permission: 'automation.create' },
];

export function useSetupProgress() {
  const [mutationLoading, setMutationLoading] = useState(false);

  const {
    data,
    error,
    isLoading,
    isValidating,
    mutate
  } = useSWR(
    ["setup-progress"],
    () => clinikoApi.getSetupProgress().then(res => res.data),
    {
      revalidateOnFocus: false,
      dedupingInterval: 60000, // Deduplicate requests within 60 seconds
    }
  );

  return {
    progress: data ?? null,
    error,
    loading: isLoading || isValidating || mutationLoading,
    isFetching: isLoading || isValidating,
    isMutating: mutationLoading,
    refresh: mutate
  };
}
